// extracted by mini-css-extract-plugin
export var avatar = "_oc-3";
export var avatarContainer = "_oc-2";
export var avatarSpacer = "_oc-5";
export var avatarSpacerContainer = "_oc-4";
export var avatarStackContainer = "_oc-1";
export var bubble = "_oc-0";
export var remainderBubble = "_oc-6";